<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this Group Link?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'group-link-delete-modal-' + data?.id">
  <div class="content-wrapper">
    <div class="details-grid">
      <div class="column">
        <div class="input-line">
          <div>
            <span><b>Name</b></span>
          </div>
          <div>
            <p>{{ data?.name }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>URL</b></span>
          </div>
          <div>
            <p>{{ data?.slug }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Description</b></span>
          </div>
          <div>
            <p>{{ data?.description || '-' }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Buyer Type ID</b></span>
          </div>
          <div>
            <p>{{ data?.defaultBuyerTypeId }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Buyer Type Name</b></span>
          </div>
          <div>
            <p>{{ data?.defaultBuyerTypeName || '-' }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Group Link Status</b></span>
          </div>
          <div>
            <p>{{ data?.isActive ? 'Enabled' : 'Disabled' }}</p>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="input-line">
          <div>
            <span><b>Max Sale Tickets</b></span>
          </div>
          <div>
            <p>{{ data?.maxTickets }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Min Sale Tickets</b></span>
          </div>
          <div>
            <p>{{ data?.minTickets }}</p>
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>ADA Hold Codes</b></span>
          </div>
          <div class="tags-container">
            @for (code of data?.adaHoldCodes; track code) {
              <span class="code-tag">{{ code }}</span>
            } @empty {
              <p>-</p>
            }
          </div>
        </div>
        <div class="input-line">
          <div>
            <span><b>Regular Hold Codes</b></span>
          </div>
          <div class="tags-container">
            @for (code of data?.regularHoldCodes; track code) {
              <span class="code-tag">{{ code }}</span>
            } @empty {
              <p>-</p>
            }
          </div>
        </div>

        <div class="input-line">
          <div>
            <span><b>Private Selling Status</b></span>
          </div>
          <div>
            <p>{{ data?.isPrivateSelling ? 'Enabled' : 'Disabled' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      variant="secondary"
      [attr.data-cy]="'group-link-delete-modal-cancel-button-' + data?.id"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      variant="destructive"
      [attr.data-cy]="'group-link-delete-modal-confirm-button-' + data?.id"
      (onClick)="onConfirm(data?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
